import { Component, Input, OnChanges, OnInit, Output, EventEmitter, ViewChild, ElementRef } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';
import { Validator } from 'projects/core/src/lib/helpers/validator';

@Component({
  selector: 'app-form-control',
  templateUrl: './form-control.component.html',
  styleUrls: ['./form-control.component.scss']
})
export class FormControlComponent implements OnInit, OnChanges {

  controlConfig: any = {
    rows: 5,
    autoResize: false
  };

  @ViewChild('field') field: ElementRef;

  @Input() control: UntypedFormControl = null;
  @Input() cid: string = null;
  @Input() label: string = null;
  @Input() type: string = null;
  @Input() basevalue: any = null;
  @Input() optionlabel: any = null;
  @Input() edit = true;
  @Input() options: Array<any> = [];
  @Input() config: any;
  @Input() min: number;
  @Input() max: number;
  @Input() step: number;
  @Input() readonlyInput: boolean;
  @Input() minDate: any;

  @Output() changed = new EventEmitter<any>();

  constructor() { }

  ngOnInit(): void {
  }

  ngOnChanges(): void {
    if (Validator.isObject(this.config)) {
      Object.keys(this.config).forEach((key: string) => {
        this.controlConfig[key] = this.config[key];
      });
    }
  }

  onSelect(): void {
    this.changed.emit();
  }

  focus(): void {
    this.field.nativeElement.focus();
  }

  select(): void {
    this.field.nativeElement.select();
  }

}
